import {cn} from '@/utils';
import React from 'react';

const InvitationIntro = ({hasBg = false}: {hasBg?: boolean}) => {
  return (
    <div
      className={cn(
        'relative flex flex-col items-center z-[2]',
        hasBg ? 'bg-[#7B4D16]' : 'mb-[5rem]',
      )}>
      {hasBg && (
        <div
          className="absolute top-0 left-0 w-[23.4375rem] h-[50.75rem] bg-full bg-no-repeat"
          style={{
            backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-bg.webp')})`,
          }}
        />
      )}
      <div
        className={cn(
          'w-[21.8125rem] h-[66.875rem] bg-full bg-no-repeat z-[1]',
          hasBg && 'mt-[14.3125rem]',
        )}
        style={{
          backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-f1.webp')})`,
        }}
      />
      <div
        className={'w-[21.8125rem] h-[90.75rem] bg-full bg-no-repeat z-[1]'}
        style={{
          backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-f2.webp')})`,
        }}
      />
    </div>
  );
};

export default InvitationIntro;
